import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ShareReferenceLocationState } from '$types/LocationState';
import {
  createPositionWithSharedRoster,
  duplicatePositionAfterLogin,
} from '$api/auth.service';
import { userLanguage } from '$translations/index';
import { warningHandler } from '$store/utils/warning-handler';
import { ErrorMessageEs, ErrorMessageEn } from '$constants/alerts';
import EmployerSPKLayout, {
  ActiveEmployerLayoutPageType,
} from '$components/EmployerDashboard/EmployerSPKLayout';
import PositionPage from '../Positions/PositionPage';

const PositionPageLayout = () => {
  const [isModalPositionOpen, setIsModalPositionOpen] = useState(false);
  const location = useLocation() as ShareReferenceLocationState;
  const navigate = useNavigate();
  const toggleIsModalPositionOpen = useCallback(
    () => setIsModalPositionOpen((prev) => !prev),
    []
  );

  useEffect(() => {
    (async () => {
      if (location?.state?.shareReferenceId) {
        await duplicatePositionAfterLogin(
          location?.state?.shareReferenceId
        ).catch((response) => {
          const errorType =
            response?.response?.data?.statusCode === 400
              ? 'AlreadyDuplicatedPosition'
              : 'DuplicateGeneralErrorMessage';
          const errorMessage =
            userLanguage === 'es'
              ? ErrorMessageEs[errorType]
              : ErrorMessageEn[errorType];
          warningHandler(
            '[DuplicatePositionAfterLogin]',
            errorMessage,
            response,
            true
          );
        });
      }

      if (location?.state?.shareCandidatesIds) {
        await createPositionWithSharedRoster(
          location?.state?.shareCandidatesIds
        ).catch((response) => {
          const errorMessage =
            userLanguage === 'es'
              ? ErrorMessageEs.CreatePositionWithSharedRosterError
              : ErrorMessageEn.CreatePositionWithSharedRosterError;
          warningHandler(
            '[CreatePositionWithSharedRoster]',
            errorMessage,
            response,
            true
          );
        });
      }

      // Avoids user calling again multiple times to the endpoint if he hits refresh
      if (
        location?.state?.shareCandidatesIds ||
        location?.state?.shareReferenceId
      ) {
        navigate(location.pathname, { replace: true });
      }
    })();
  }, [location, navigate]);

  return (
    <EmployerSPKLayout
      externalIsModalPositionOpen={isModalPositionOpen}
      activePage={ActiveEmployerLayoutPageType.positions}
    >
      <PositionPage toggleIsModalPositionOpen={toggleIsModalPositionOpen} />
    </EmployerSPKLayout>
  );
};

export default PositionPageLayout;
